module.exports = __webpack_public_path__ + "static/media/literacy_programs.7e39ec8c.png";